import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './home/';
import { Animal } from './animais/';
import { AnimalEdit } from './animais/';
import { Empresa } from './empresas/';
import { EmpresaEdit } from './empresas/';
import { Fazenda } from './fazendas/';
import { FazendaEdit } from './fazendas/';
import { Parto } from './partos/';
import { PartoEdit } from './partos/';
import { Tanque, TanqueEdit, TanqueDashboard } from './tanques/';
import { Prefeitura } from './prefeituras/';
import { PrefeituraEdit } from './prefeituras/';
import { Convenio } from './convenios/';
import { ConvenioEdit } from './convenios/';
import { Usuario } from './usuarios/';
import { UsuarioEdit } from './usuarios/';
import { Login } from './login/login.component';
import { PasswordReset } from './login/passwordReset.component';
import { RequestPasswordReset } from './login/requestPasswordReset.component';
import { Visita } from './visitas/';
import { VisitaEdit } from './visitas/';
import { TermoUsoEdit } from './termosUso/';
import { TermoUso } from './termosUso/';
import { history } from './_helpers';
import { PrivateRoute } from './_components';
import { RelatorioFiltro, RelatorioLog } from './relatorios';
import { CertificadosAVencer } from './certificadosAVencer/certificadoAVencer.component';
import { VersaoSistemaEdit } from './versoesSistemas';
import { VersaoSistema } from './versoesSistemas';
import ExecucoesComponent from './relatorios/execucoes.component';
import { BannerEdit } from './banners/';
import { Banner } from './banners/';

class App extends Component {
    render() {
        return (
            <div className="App">
                <Router>
                    <div id="app">
                        <Routes>
                            <Route path='/home' element={<PrivateRoute component={Home} />} />
                            <Route path='/animais' element={<PrivateRoute component={Animal} />} />
                            <Route path='/animal' element={<PrivateRoute component={AnimalEdit} />} />
                            <Route path='/animal/:id' element={<PrivateRoute component={AnimalEdit} />} />
                            <Route path='/banners' element={<PrivateRoute component={Banner} />} />
                            <Route path='/banner' element={<PrivateRoute component={BannerEdit} />} />
                            <Route path='/banner/:id' element={<PrivateRoute component={BannerEdit} />} />
                            <Route path='/empresas' element={<PrivateRoute component={Empresa} />} />
                            <Route path='/empresa' element={<PrivateRoute component={EmpresaEdit} />} />
                            <Route path='/empresa/:id' element={<PrivateRoute component={EmpresaEdit} />} />
                            <Route path='/fazendas' element={<PrivateRoute component={Fazenda} />} />
                            <Route path='/fazenda' element={<PrivateRoute component={FazendaEdit} />} />
                            <Route path='/fazenda/:id' element={<PrivateRoute component={FazendaEdit} />} />
                            <Route path='/partos' element={<PrivateRoute component={Parto} />} />
                            <Route path='/parto' element={<PrivateRoute component={PartoEdit} />} />
                            <Route path='/parto/:id' element={<PrivateRoute component={PartoEdit} />} />
                            <Route path='/prefeituras' element={<PrivateRoute component={Prefeitura} />} />
                            <Route path='/prefeitura' element={<PrivateRoute component={PrefeituraEdit} />} />
                            <Route path='/prefeitura/:id' element={<PrivateRoute component={PrefeituraEdit} />} />
                            <Route path='/convenios' element={<PrivateRoute component={Convenio} />} />
                            <Route path='/convenio' element={<PrivateRoute component={ConvenioEdit} />} />
                            <Route path='/convenio/:id' element={<PrivateRoute component={ConvenioEdit} />} />
                            <Route path='/usuarios' element={<PrivateRoute component={Usuario} />} />
                            <Route path='/usuario' element={<PrivateRoute component={UsuarioEdit} />} />
                            <Route path='/usuario/:id' element={<PrivateRoute component={UsuarioEdit} />} />
                            <Route path='/visitas' element={<PrivateRoute component={Visita} />} />
                            <Route path='/visita' element={<PrivateRoute component={VisitaEdit} />} />
                            <Route path='/visita/:id' element={<PrivateRoute component={VisitaEdit} />} />
                            <Route path='/termosUsos' element={<PrivateRoute component={TermoUso} />} />
                            <Route path='/termosUso' element={<PrivateRoute component={TermoUsoEdit} />} />
                            <Route path='/termosUso/:id' element={<PrivateRoute component={TermoUsoEdit} />} />
                            <Route path='/certificadosAVencer' element={<PrivateRoute component={CertificadosAVencer} />} />
                            <Route path='/versoesSistemas' element={<PrivateRoute component={VersaoSistema} />} />
                            <Route path='/versaoSistema' element={<PrivateRoute component={VersaoSistemaEdit} />} />
                            <Route path='/versoesSistemas/:id' element={<PrivateRoute component={VersaoSistemaEdit} />} />
                            <Route path='/relatorioFiltro' element={<PrivateRoute component={RelatorioFiltro} />} />
                            <Route path='/relatorioLog' element={<PrivateRoute component={RelatorioLog} />} />
                            <Route path='/tanques' element={<PrivateRoute component={Tanque} />} />
                            <Route path='/dashboardTanques' element={<PrivateRoute component={TanqueDashboard} />} />
                            <Route path='/tanque' element={<PrivateRoute component={TanqueEdit} />} />
                            <Route path='/tanque/:id' element={<PrivateRoute component={TanqueEdit} />} />
                            <Route path='/execucoes' element={<PrivateRoute component={ExecucoesComponent} />} /> {/* rota adicionada */}
                            <Route path='/password-reset' element={<PasswordReset />} />
                            <Route path='/request-password-reset' element={<RequestPasswordReset />} />
                            <Route path='/' element={<Login />} />
                        </Routes>
                    </div>
                </Router>
            </div>
        );
    }
}
export default App;